import * as yup from 'yup';

export const variantsOnTaskSchema = yup.object().shape({
  dependingOnConditions: yup.array().of(yup.number()),
});
